import React, { useState, useEffect, useCallback } from "react";
import { db, auth, storage } from "../firebaseConfig";
import { doc, updateDoc, getDoc, setDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../utils/cropImage";
import ProgressBar from "../components/ProgressBar";
import "../styles/CompleteProfile.css";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const CompleteProfile4 = () => {
  const [user] = useAuthState(auth);
  const [photoURL, setPhotoURL] = useState("");
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      const fetchProfile = async () => {
        try {
          const docRef = doc(db, "members", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setPhotoURL(data.photoURL || "");
          }
        } catch (error) {
          console.error("Error fetching profile:", error.message);
          setError("プロフィールの取得中にエラーが発生しました。");
        }
      };
      fetchProfile();
    }
  }, [user]);

  const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        alert("ファイルサイズは5MB以下にしてください。");
        return;
      }
      const validMimeTypes = ["image/jpeg", "image/png"];
      if (!validMimeTypes.includes(file.type)) {
        alert("画像形式はJPEGまたはPNGのみ対応しています。");
        return;
      }
      setImage(URL.createObjectURL(file));
      setShowCropper(true);
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSave = async () => {
    if (!user) return;

    try {
      let newPhotoURL = photoURL;

      if (image) {
        const croppedImage = await getCroppedImg(image, croppedAreaPixels);
        const storageRef = ref(storage, `profile_images/${user.uid}`);
        await uploadBytes(storageRef, croppedImage);
        newPhotoURL = await getDownloadURL(storageRef);
        setPhotoURL(newPhotoURL);
      }

      const userDocRef = doc(db, "members", user.uid);
      await setDoc(userDocRef, { photoURL: newPhotoURL }, { merge: true });

      navigate("/complete-profile5");
    } catch (error) {
      console.error("Error saving profile:", error.message);
      setError("プロフィールの保存中にエラーが発生しました。");
    }
  };

  return (
    <div className="complete-profile-container">
      <ProgressBar step={4} totalSteps={6} />

      <h2>プロフィール画像を選択する</h2>
      {error && <p className="error-message">{error}</p>}

      <div className="profile-picture-container">
        <div className="image-container">
          {photoURL ? <img src={photoURL} alt="Profile" className="profile-picture" /> : <img src="/images/default.png" alt="Default" className="profile-picture" />}
        </div>
        <label className="custom-file-upload">
          画像を選択
          <input type="file" onChange={handleImageChange} className="file-input" />
        </label>
      </div>

      <button onClick={handleSave} className="complete-profile-button">次へ</button>

{showCropper && (
  <div className="crop-container">
    <button onClick={() => setShowCropper(false)} className="crop-button">✖</button>
    <Cropper
      image={image}
      crop={crop}
      zoom={zoom}
      aspect={1}
      onCropChange={setCrop}
      onZoomChange={setZoom}
      onCropComplete={onCropComplete}
    />
    <div className="crop-controls">
      <button onClick={handleSave} className="crop-button1">保存する</button>
    </div>
  </div>
)}

    </div>
  );
};

export default CompleteProfile4;
